module.exports = __webpack_public_path__ + "img/sorry.04064af1.png";